export default __webpack_public_path__ + "cb9531b.png";